<button class="button-icon" [attr.type]="nativeType()" [attr.aria-label]="ariaLabel()"
    [style.--button-icon-color]="iconColor()" [style.--button-icon-hover-color]="iconHoverColor()"
    [class.button-icon--has-hover-icon]="!!iconHoverColor()"
    [disabled]="disabled()" (click)="emitPressed($event)">
    <app-icon class="button-icon__icon button-icon__icon--base" [icon]="icon()" [color]="iconColor()"
        [forceMask]="!!iconColor()" [width]="width()" [height]="height()" />
    @if (iconHoverColor()) {
    <app-icon class="button-icon__icon button-icon__icon--hover" [icon]="icon()" [color]="iconHoverColor()"
        [forceMask]="true" [width]="width()" [height]="height()" />
    }
</button>